$(document).ready(function() {

    $('.hero').not('.slick-initialized').slickOLD({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        cssEase: 'linear',
        speed: 900,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        adaptiveHeight: false,
    });

    $('.pub-gallery').slickOLD({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav',
        prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
        nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    });

    $('.slider-nav').slickOLD({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.pub-gallery',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true
    });
    $('.offers_static_block').slickOLD({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
        ]
      
    });

    if($('body').hasClass('premium')) {
        const gallery = $('.gallery-block > .images');
        // On init
        $(gallery).on('init', function (event, slick) {
            var currentSlide = $(gallery).find('.slick-current');
            var prevSlide = $(currentSlide).prev();
            var prevElem = $(prevSlide).find('li');
            $(prevElem).css('paddingRight', '18px');
            $(prevElem).css('opacity', '0.5');

            var nextSlide = $(currentSlide).next();
            var nextElem = $(nextSlide).find('li');
            $(nextElem).css('paddingLeft', '18px');
            $(nextElem).css('opacity', '0.5');

            $(prevElem).click(function () {
                $('.sliderPrev').trigger('click');
            });
            $(nextElem).click(function () {
                $('.sliderNext').trigger('click');
            });

            $('ul.slick-dots').children().each(function (k, v) {
                if (k >= 5) {
                    $(this).remove();
                }
            })
        });

        $(gallery).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            prevArrow: ".sliderPrev",
            nextArrow: ".sliderNext",
            centerMode: true,
            centerPadding: '14vw',
            dots: true,
            appendDots: '.block.gallery-block',
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        centerPadding: '5vw'
                    }
                },
                {
                    breakpoint: 750,
                    settings: {
                        dots: false,
                        centerPadding: '0vw'
                    }
                },
            ],
            customPaging: function (slider, i) {
                return $('<button type="button" />');
            }
        });
        $(gallery).on('breakpoint', function (event, slick, breakpoint) {
            $('ul.slick-dots').children().each(function (k, v) {
                if (k >= 5) {
                    $(this).remove();
                }
            });

        });

        // On before slide change
        $(gallery).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var currentSlide = $(gallery).find('.slick-current');
            var prevSlide = $(currentSlide).prev();
            var prevElem = $(prevSlide).find('li');
            $(prevElem).css('paddingRight', '0px');
            $(prevElem).css('opacity', '1');

            var nextSlide = $(currentSlide).next();
            var nextElem = $(nextSlide).find('li');
            $(nextElem).css('paddingLeft', '0px');
            $(nextElem).css('opacity', '1');

            $(prevElem).unbind('click');
            $(nextElem).unbind('click');
        });

        // On after slide change
        $(gallery).on('afterChange', function (event, slick, currentSlide) {

            var currentSlide = $(gallery).find('.slick-current');
            var prevSlide = $(currentSlide).prev();
            var prevElem = $(prevSlide).find('li');
            $(prevElem).css('paddingRight', '18px');
            $(prevElem).css('opacity', '0.5');

            var nextSlide = $(currentSlide).next();
            var nextElem = $(nextSlide).find('li');
            $(nextElem).css('paddingLeft', '18px');
            $(nextElem).css('opacity', '0.5');

            $(prevElem).click(function () {
                $('.sliderPrev').trigger('click');
            });
            $(nextElem).click(function () {
                $('.sliderNext').trigger('click');
            });
        });


        $('.menu-btn-premium').click(function () {
            $('.main-nav').toggleClass('active');
            $('#menu-main-menu').toggleClass('active');
            $(this).toggleClass('open');
        });
    }

    $('.menu-btn').click(function() {
        $('.main-nav').addClass('active');
        $('#menu-main-menu').addClass('active');
    });

    $('.close-menu').click(function() {
        $('.main-nav').removeClass('active');
        $('#menu-main-menu').removeClass('active');
    });

    $('.menu-item-has-children').click(function() {
        $(this).children('.dropdown').toggleClass('active');
        $(this).children('.sub-menu').toggleClass('active');
        $(this).toggleClass('active');
    });

    $('.filter-head').click(function() {
        $(this).toggleClass('active');
        $('.search-bar').toggleClass('active');
        $('.category-filters').toggleClass('active');
    });

    $('.table-iframe').click(function(e) {
        e.preventDefault();
        var $designmynight_site_id  = $(this).data('designmynight_site_id');
        if($designmynight_site_id){
            $('#table-book-designmynight').addClass('active');
        }else{
            $('#table-book-new').addClass('active');
        }

    });

    if (typeof window.location.search.substr(1) != "undefined") {
        if (window.location.search.substr(1) === "book-a-table") {
            $('#table-book-old').addClass('active');
        }
    }

    $('.close-iframe').click(function() {
        $('.table-book-wrap').removeClass('active');
    });

    $('.close-popup').click(function() {
        $('.popup-wrap').removeClass('enable-popup');
    });

    var scrollTop = 0;
    SCROLL_THRESHOLD = 30;
    $(window).scroll(function() {
        scrollTop = $(window).scrollTop();
        // $('.counter').html(scrollTop);

        if (scrollTop >= SCROLL_THRESHOLD) {
            $('.page-head').addClass('scrolled-nav');
        } else if (scrollTop < SCROLL_THRESHOLD) {
            $('.page-head').removeClass('scrolled-nav');
        }
    });
    $('.hero-book').click(function() {
        $('.hero-popup').addClass('active');
    });

    $('.form-close').click(function() {
        $('.hero-popup').removeClass('active');
    });

    if($('body').hasClass('premium')) {
        checkTop();

        $('.faqs .list-element').click(function(e){
            $(this).toggleClass('open');
        });

        $('.book-bar input[type="text"]').each(function(k,v){
            $(v).datepicker({ dateFormat: 'dd/mm/yy' });            
        });

        if($('.book-bar form').length){

            $('.book-bar form').each(function(){
                $(this).submit(function(e){  

                    if($(this).find('input[name="dateFrom"]').val() && $(this).find('input[name="dateTo"]').val()){                        
                        
                        var arrival = convertUKDateStringToUSDateString($(this).find('input[name="dateFrom"]').val())
                        var departure = convertUKDateStringToUSDateString($(this).find('input[name="dateTo"]').val())
                        var date1 = new Date(arrival);
                        var date2 = new Date(departure);                
                  
                        // To calculate the time difference of two dates
                        var Difference_In_Time = date2.getTime() - date1.getTime();
                          
                        // To calculate the no. of days between two dates
                        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

                        $(this).find('input[name="numNights"]').val(Difference_In_Days);                                       

                    } else {
                        $(this).append('<div class="alert alert--error">Please enter dates in the format dd/mm/yyyy</div>');
                        e.preventDefault();
                    }
                });
            });
        }         

        if($('.vimeo').length > 0){
            checkVimeo();
        }

    }

    $('button[name="add-to-cart"]').on('click', function(){
        fbq('track', 'AddToCart');
    });

    $('a.checkout-button').on('click', function(){
        fbq('track', 'InitiateCheckout');
    });


    $('.slides-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: false,
        centerMode: true,
        centerPadding: '0',
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 2000
    });

    $('.global-floating-cta-form .form-close-btn, .global-floating-cta-form .form-open-btn').on('click', function(){
        $('.global-floating-cta-form').toggleClass('active');
    });

    $('.custom-anchor-tag').off('click');
    $('.custom-anchor-tag').on('click', function() {
        var _href = $(this).data('href');
        if(_href != '' && _href != undefined){
            location.href = _href;
        }
        return false;
    });
});
$(window).resize(function() {
    checkTop();
//    fixGalleryTabs();
    if($('.vimeo').length > 0){
        checkVimeo();
    }
});

function checkVimeo(){
    var ratio = $('.vimeo').parent().data('ratio');
    var wrapper = $('.vimeo').parent().parent();
    var W = $(wrapper).width();
    var estH = Math.round(W * (1/ratio));
    $(wrapper).height(estH);
}

function fixGalleryTabs(){
    $('.gallery-block .slick-dots').children().gt(4).each(function(k,v){
        $(v).remove();
    });
}

function checkTop(){
    var H = Math.floor($('header.page-head').outerHeight() - 1);
    //$('.flexible-content-wrap-premium').css('paddingTop', H+'px');

    var W = $(window).width();
    var calc;
    if(W <= 750){
        calc = 'calc(50vh - '+H+'px)';
    }else{
        calc = 'calc(100vh - '+H+'px)';
    }
    // $('.hero-block-wrapper img').css('height', calc);
    // $('.hero-block-wrapper .videowrapper').css('height', calc);
    // $('.hero-block-wrapper .videoplayer').css('height', calc);
    // $('.hero-block-wrapper .overlay-wrapper').css('height', calc);

}

function convertUKDateStringToUSDateString(date){
    
    var dateParts = date.split("/");
    
    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

    return dateObject.toString();
}

if($('.hero-book').length > 0) {
    var fixmeTop = $('.hero-book').offset().top - $("header.page-head").height(); // get initial position of the element
    $(window).scroll(function () {
        var currentScroll = $(window).scrollTop();

        if (currentScroll >= fixmeTop) {
            $('.hero-book').css({
                position: 'fixed',
                bottom: '0',
                top: 'auto'

            });
        } else {
            $('.hero-book').removeAttr("style");
        }

    });
}